'use strict';

/**
 * Creates an instance of HttpResponse
 */
class HttpResponse {
    constructor() {
        this.statusCode = null;
        this.body = null;
        this.headers = null;
    }
}

module.exports = HttpResponse;
